import React, { FC, useCallback, useState } from "react";

import TransparentPage from "../common/navigation/PageTransparent";

import style from "../../styles/tileDownloaderStyle";
import { useNavigate } from "react-router-dom";
import MapDownloadStep1 from "./components/MapDownloadStep1";
import MapDownloadStep2 from "./components/MapDownloadStep2";
import MapDownloadStep3 from "./components/MapDownloadStep3";
import MapDownloadStep4 from "./components/MapDownloadStep4";

export interface DownloadState {
  extent: ol.Extent | null;
  startZoom: number | null;
  endZoom: number | null;
  name: string | null;
}

const MapDownloadPage: FC = () => {
  const [state, setState] = useState<DownloadState>({
    extent: null,
    startZoom: null,
    endZoom: null,
    name: null,
  });

  const currentStep =
    !state.extent || !state.startZoom ? "extentAndStartZoom" : !state.endZoom ? "endZoom" : !state.name ? "name" : "downloading";

  const navigate = useNavigate();

  const handleBack = useCallback(() => {
    if (currentStep === "extentAndStartZoom") {
      navigate("../");
    } else if (currentStep === "endZoom") {
      setState((s) => ({ ...s, extent: null, startZoom: null }));
    } else if (currentStep === "name") {
      setState((s) => ({ ...s, endZoom: null }));
    }
  }, [currentStep, navigate]);

  const handleNext = useCallback((values: Partial<DownloadState>) => setState((s) => ({ ...s, ...values })), []);

  const css = style;

  return (
    <TransparentPage>
      <div style={css.wrapper as any}>
        {currentStep === "extentAndStartZoom" ? (
          <MapDownloadStep1 onNext={handleNext} onBack={handleBack} />
        ) : currentStep === "endZoom" ? (
          <MapDownloadStep2 state={state} onNext={handleNext} onBack={handleBack} />
        ) : currentStep === "name" ? (
          <MapDownloadStep3 state={state} onNext={handleNext} onBack={handleBack} />
        ) : (
          <MapDownloadStep4 state={state} onNext={handleNext} onBack={handleBack} />
        )}
      </div>
    </TransparentPage>
  );
};

export default MapDownloadPage;
